import { createStore as _createStore, applyMiddleware, compose } from "redux";
import createMiddleware from "./middleware/clientMiddleware";
import reduxThunk from "redux-thunk";
import reducer from "./modules/reducer";

/* hack to simplify accessing the api client in other middlewares */
export let api = null;

export default function createStore(client, data) {
  api = client;

  const middleware = [createMiddleware(client), reduxThunk];
  const composeEnhancers =
    (global.window &&
      process.env.NODE_ENV === "development" &&
      global.window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
    compose;
  const store = _createStore(reducer, data, composeEnhancers(applyMiddleware(...middleware))); //finalCreateStore(reducer, data);

  if (module.hot) {
    module.hot.accept("./modules/reducer", () => {
      store.replaceReducer(require("./modules/reducer"));
    });
  }

  return store;
}
